import * as ng from 'angular';

ng.module('e360')
   .directive('watermark', watermarkDirective);

watermarkDirective.$inject = ['$timeout', '$window'];
export function watermarkDirective(
   $timeout:ng.ITimeoutService,
   $window:ng.IWindowService
):ng.IDirective {
   return {
      restrict: 'C',
      link: watermarkDirectiveLinkFn
   };

   function watermarkDirectiveLinkFn(scope, element, attrs) {
      let nav = element.closest('nav');
      let brand = nav.find('.brand');
      let routes = nav.find('.routes');

      scope.$watch('current', function () {
         $timeout(measure, 0);
         measure();
      });

      $($window).resize(measure);

      measure();

      function measure() {
         let visibleHeight = nav.height() - element.outerHeight(true);
         let navItemsHeight = brand.outerHeight(true) + routes.outerHeight(true);

         if (visibleHeight > navItemsHeight) {
            element.addClass('anchored');
         } else {
            element.removeClass('anchored');
         }
      }
   }
}
